import React from "react";

import { PageMessage } from "@picklebet/ui";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";

import { ReactComponent as ErrorIcon } from "assets/illustrations/account-error.svg";

type CheckBlockedProps = {
  permission: string;
  children?: React.ReactNode;
  type: "deposit" | "withdraw";
};

const CheckBlocked = ({ children, permission, type }: CheckBlockedProps) => {
  if (permission === "BLOCKED") {
    return (
      <PageMessage
        image={<ErrorIcon />}
        title={`Your account is under review`}
        subTitle={`During the review period you are not permitted to ${type}`}
      >
        <SupportLink openLiveChat type={`button`}>
          Contact Support
        </SupportLink>
      </PageMessage>
    );
  }

  return <>{children}</>;
};

export { CheckBlocked };
